/** Tracks web audio alerts that take priority over transcript warnings.
 * V2 keeps an alert active when its popover is briefly hidden by a menu or keyboard.
 */
const openByOwner = new Map<symbol, string>();
const listeners = new Set<() => void>();

export const subscribeWebAudioLevelAlert = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const isWebAudioLevelAlertOpen = (recordingId: string | null) =>
  !!recordingId && Array.from(openByOwner.values()).includes(recordingId);

export const setWebAudioLevelAlertOpen = (
  owner: symbol,
  recordingId: string | null,
  open: boolean
) => {
  const previous = openByOwner.get(owner);
  if (open && recordingId) openByOwner.set(owner, recordingId);
  else openByOwner.delete(owner);
  if (previous !== openByOwner.get(owner)) listeners.forEach((listener) => listener());
};
